
<template>
    <div id="listVendorPayment">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> AP Positive Pay Listing - JP Morgan Chase</div>
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <div class="btn-groups text-right">
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportReports()">
                            <i class="fp-export"></i> Export
                        </a>
                    </div>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content vendor-payment-list">
                        <data-table-filter-config :moduleName="'apPositivePayReport'" ref="apPositivePayReport" @cancelSelection="cancelAll" :allowSameFilter="'allow'">
                        </data-table-filter-config>
                        <div class="form-row">
                            <div id="payment-list-section" :class="paymentListClass == ''? 'col-md-12': paymentListClass">
                            <div class="data-table bg-white overflow-hidden">
                              <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process. batch no. is {{batchNum}}. <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank" @click.native="batchProcess = 0"> Click Here</router-link> to check file status!</p>
                              <section class="data-table bg-white">
                                    <custom-pagination
                                            :page-changed="onPageChange"
                                            :per-page-changed="onPerPageChange" :position="'top'"
                                            :moduleName="'apPositivePayReport'" ref="paginateComponent">
                                    </custom-pagination>

                                    <vue-good-table
                                        ref="apPositivePayReport"
                                        mode="remote"
                                        title="Vendor Payment"
                                        @on-page-change="onPageChange"
                                        @on-sort-change="onSortChange"
                                        @on-column-filter="onColumnFilter"
                                        @on-per-page-change="onPerPageChange"
                                        @on-selected-rows-change="selectionChanged"
                                        @on-select-all="onSelectAll"
                                        :totalRows="totalRecords"
                                        :columns="userColumns"
                                        :rows="rows"
                                        :paginationOptions="{
                                            enabled: false,
                                            position: 'both',
                                            perPage: perPage,
                                            perPageDropdown:dropDownPerPage,
                                            dropdownAllowAll: false

                                        }"
                                        :select-options="{
                                            enabled: canPay,
                                            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                            selectionInfoClass: 'custom-class',
                                            selectionText: 'rows selected',
                                            clearSelectionText: 'clear',
                                        }"
                                        :search-options="{
                                            enabled: false,
                                        }"
                                        :sort-options="{
                                            enabled: true,
                                        }"
                                    >
                                    </vue-good-table>
                                    <custom-pagination
                                            :page-changed="onPageChange"
                                            :per-page-changed="onPerPageChange"
                                            :moduleName="'apPositivePayReport'" ref="paginateComponent">
                                    </custom-pagination>

                                </section>
                            </div>
                            
                            </div>
                        </div>
                    </div>
                </div>

            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>

<script>

    import Vue from 'vue';

    
    


    import EventBus from ".././event-bus";
    import {commonMixins} from '../../mixins/commonMixins';
    import {dataTableMixins} from '../../mixins/dataTableMixins';

    var contex
    export default {
        name: "APPositivePayListing",
        metaInfo: {
            // title will be injected into parent titleTemplate
            title: "AP Positive Pay Listing  | " +process.env.COPYRIGHT_NAME
        },
        mixins:[commonMixins,dataTableMixins],

        data: () => ({
            firstLoad: 0,
            userRole:"",
            permissions: [],
            userColumns:[],
            columns: [
                {
                    label: 'Transaction Indicator',
                    field: 'pp_status',
                    filterable: false,
                    fpFieldType:"option",
                    hidden:false
                },
                {
                    label: 'Bank Account',
                    field: 'bank_account',
                    filterable: false,
                    fpFieldType:"text",
                    hidden:false,
                    sortable:false
                },
                {
                    label: "Payment Number",
                    field: "payment_number",
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false
                },
                {
                    label: 'Payment Date',
                    field: 'pp_payment_date',
                    filterable: true,
                    fpFieldType:"date",
                    hidden:false
                },
                {
                    label: "Payment Amount",
                    field: "amount",
                    fpFieldType:"integer",
                    filterable: true,
                    type:'number',
                    hidden:false
                },
                {
                    label: "Vendor Number",
                    field: "vendor_code",
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false
                },
                {
                    label: "Entity Name",
                    field: "vendor",
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false
                },
                {
                    label: "Payment Type",
                    field: "payment_type",
                    fpFieldType:"text",
                    filterable: true,
                    hidden:false
                },
            ],
            rows: [],
            totalRecords: 0,
            cantAccessPage:"",
            loading:false,
            flag:"",
            listFlag:"ap_positive_pay",
            canPay:false,
            path:'',
            canView:false,
            reason:"",
            reason_error_msg:"",
            userArr:[],
            fieldArr:[],
            payment_date:'',
            paymentListClass:'',
            currentData:"",
            defaultClass:true,
            showResetBtn:false,
            month:'',
            action:'list',
            pageKey:"_ap_positive_pay_listing_report",
            batchProcess:0,
            batchNum:"",
        }),
        watch: {

            permissions: function(permission){
                var self = this;
                permission.forEach(function (permissions) {
                    if(permissions.name == 'ap_positive_pay_listing_report') {
                        self.cantAccessPage = true;
                    }
                });
                if(self.cantAccessPage == ''){
                    self.cantAccessPage = false;
                }
            },
        },

        mounted: function() {
            this.getPermissions();
        },
        created: function() {
            this.serverParams.stopRequest = true;
        },
        methods: {
            
            cancelAll: function (cancelAll) {
              this.$refs.apPositivePayReport.unselectAllInternal();
            },
            loadList() {

                var self = this;
                var use = [];
                self.loading = true;

                // if ( self.action != 'list') {
                    self.listFlag = "ap_positive_pay";
                // }
                
                var fields = {
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    flag:self.listFlag,
                    action:self.action,
                    all:self.serverParams.selectedAll,
                    id:use,
                    payment_date:self.payment_date,
                    tagflag:''
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/vendor-payment/list",
                    type: "POST",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;

                        if ( data.status == "success" ) {
                            if ( self.action == "export" ||  self.action == "export_queue") { 

                                if ( data.code == "201" ) {
                                    alert(data.message);
                                } else {
                                    if ( self.action == "export" ) {
                                        self.excel = data.content.web;
                                        var save = document.createElement("a");
                                        save.href = self.excel;
                                        save.download = data.content.web;
                                        save.target = "_blank";

                                        document.body.appendChild(save);
                                        save.click();
                                        document.body.removeChild(save);

                                    } else {

                                        self.batchProcess = 1;
                                        self.batchNum = data.content;
                                    }
                                }

                                self.action = "list";
                                // self.loadList();

                            } else {
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                                self.filteredFlag = false;
                            }

                        }
                        self.listFlag = "";
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.listFlag = "";
                        self.generateStatusCodeMessage(jqXHR,false,'vendor-payment-list');
                    }
                });
            },
            
            amountFormat(amount) {

                return amount.toLocaleString('en-US', {
                    style: 'currency',
                    currency: 'USD'
                });
            },
            
        }
    };
</script>



// WEBPACK FOOTER //
// src/components/reports/APPositivePayReport.vue